import * as React from 'react';

export const ShareInfor = {
  title: 'Giới thiệu app hay nhận ngay ưu đãi',
  url: 'https://doitac.mytour.vn/',
  description:
    'Giảm ngay 20% (tối đa 2,000,000đ) cho đơn Đặt phòng Khách sạn đầu tiên của bạn bè có tài khoản trên Mytour.vn Nhập mã trên vào ô "Mã Giảm Giá" và nhận hàng chục ưu đãi khủng khi giới thiệu thành công',
  descriptionHtml: (
    <>
      Giảm ngay 20% (tối đa 2,000,000đ) cho đơn Đặt phòng Khách sạn đầu tiên của
      bạn bè có tài khoản trên{' '}
      <a href='https://mytour.vn' target='_blank' rel='noopener noreferrer'>
        <span style={{ color: '#00B6F3', textDecoration: 'none' }}>
          Mytour.vn
        </span>{' '}
      </a>
      Nhập mã trên vào ô "Mã Giảm Giá" và nhận hàng chục ưu đãi khủng khi giới
      thiệu thành công
      {/* Giảm trực tiếp{' '}
      <span style={{ fontWeight: 600 }}>300.000đ</span> cho đơn Đặt phòng khách
      sạn đầu tiên của bạn bè có tài khoản trên ứng dụng Mytour khi nhập mã trên
      vào ô “Mã Giảm Giá” và nhận tới{' '}
      <span style={{ fontWeight: 600 }}>14.400.000đ</span> khi giới thiệu thành
      công */}
    </>
  ),
  icon: '/favicon.ico',
  shareImg: '/banner_referral.png',
  subject: 'Giới thiệu app hay nhận ngay ưu đãi',
  createShareDescription: () =>
    `Tham gia Chương trình đối tác của Mytour để giúp bạn kiếm doanh thu từ trang web của mình - Mytour.vn`,
};
